import { zodResolver } from "@hookform/resolvers/zod";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "@lingui/macro";
import { defaultExperience, experienceSchema } from "@reactive-resume/schema";
import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  RichInput,
  Tooltip,
} from "@reactive-resume/ui";
import { forwardRef, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { AiActions } from "@/client/components/ai-actions";

import { SectionDialog } from "../sections/shared/section-dialog";
import { URLInput } from "../sections/shared/url-input";
import DatePicker from "react-datepicker";
import { useEffect } from "react";
const formSchema = experienceSchema;

type FormValues = z.infer<typeof formSchema>;

export const ExperienceDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultExperience,
    resolver: zodResolver(formSchema),
  });
  const [isVisible, setIsVisible] = useState(true);
  // if(form.getValues().currently_working)
  // {
  //   form.resetField('toDate')
  // }
  // if(form.getFieldState("toDate").isDirty == false){
  //   let a = form.getValues();
  //   if (a.currently_working == true)
  //   {
  //     // setIsVisible(false)
  //   }

  //   // setIsVisible(a)
  // }
  // if (isVisible==false && form.getFieldState("currently_working").isDirty == false)
  // {
  //    setIsVisible(true)

  // }
  const [selectedDate, setSelectedDate] = useState(null);
  const [error_msg, SetError]: any = useState(null);

  const handleDateChange = (date: any) => {
    date.setDate(date.getDate() + 1);
    setSelectedDate(date);
    let data = date.toISOString().split("T")[0].split("-").reverse().join("-");
    // console.log("hcl",data,date.toISOString().split('T')[0])
    form.setValue("fromDate", data);
  };

  const handleDateChange2 = (date: any) => {
    date.setDate(date.getDate() + 1);
    setSelectedDate(date);
    let data = date.toISOString().split("T")[0].split("-").reverse().join("-");
    // console.log("hcl",data,date.toISOString().split('T')[0])
    form.setValue("toDate", data);
    console.log(form.getFieldState("toDate"));
  };
  const toggleVisibility = (data: boolean) => {
    // console.log(form.getFieldState("currently_working"))
    if (data) {
      form.resetField("toDate");
    }
    // console.log("dasdasdsdasda",isVisible);
  };
  const validateDates = (fromDate: any, toDate: any) => {
    const [day, month, year]: any = fromDate.split("-");
    const [to_day, to_month, to_year]: any = toDate.split("-");
    fromDate = new Date(year, month - 1, day);
    toDate = new Date(to_year, to_month - 1, to_day);

    if (fromDate && toDate) {
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);
      console.log(fromDateObj, toDateObj);
      if (fromDateObj > toDateObj) {
        // If fromDate is greater than toDate, set error
        SetError("From Date Cannot be greater than end Date");
        console.log("dsad", error_msg);
      } else {
        // If valid, clear error
        SetError(null);
        console.log("dsada", error_msg);
      }
    }
  };

  useEffect(() => {
    validateDates(form.getValues().fromDate, form.getValues().toDate);
  }, [form.getValues().fromDate, form.getValues().toDate]);

  return (
    <SectionDialog<FormValues> id="experience" form={form} defaultValues={defaultExperience}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          name="company"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Company`}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="position"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t({
                  message: "Position",
                  context: "Position held at a company, for example, Software Engineer",
                })}
              </FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {/* <FormField
          name="date"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Date or Date Range`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder={t`March 2023 - Present`} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        {/* from date, to date */}
        <FormField
          name="fromDate"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel style={{ marginRight: "5px" }}>From Date</FormLabel>
              <FormControl style={{ display: "hidden" }}>
                <DatePicker
                  {...field}
                  selectsStart
                  // selected={field.value}
                  placeholderText={"dd-MM-yyyy"}
                  dateFormat={"dd-MM-yyyy"}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={80}
                  //   onChange={(fromDate: any) => {
                  //     field.onChange(field.value.toISOString().split('T')[0].split('-').reverse().join('/'))

                  // }}
                  onChange={handleDateChange}
                  className="custom-datepicker"
                  maxDate={new Date()}
                />
                {/* <DatePicker
                  type="text"
                  name="sdate"
                  value={field.value}
                  dateFormat="dd-MM-yyyy"
                  selected={field.value}
                  onChange={(value)=>{setValue(')}}
                /> */}
                {/* <Input {...field} type="date" placeholder="dd-mm-yyyy" value="" min="1997-01-01" max="2030-12-31"/> */}
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {!form.getValues().currently_working && (
          <FormField
            name="toDate"
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel style={{ marginRight: "5px" }}>To Date</FormLabel>
                <FormControl style={{ display: "hidden" }}>
                  <DatePicker
                    {...field}
                    selectsEnd
                    placeholderText={"dd-MM-yyyy"}
                    dateFormat={"dd-MM-yyyy"}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={80}
                    // onChange={(toDate:any) => field.onChange(toDate.toISOString().split('T')[0])}
                    onChange={handleDateChange2}
                    className="custom-datepicker"
                    maxDate={new Date()}
                  />
                </FormControl>
                <FormMessage />

                <div>{error_msg && <p style={{ color: "red" }}>{error_msg}</p>}</div>
              </FormItem>
            )}
          />
        )}
        {/* from date, to date */}

        <FormField
          name="location"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Location`}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="url"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>
                {t`Website`}{" "}
                <Tooltip content={t`webiste link`}>
                  <i className="fas fa-info-circle text-orange-500"></i>
                </Tooltip>
              </FormLabel>
              <FormControl>
                <URLInput {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="summary"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>
                {t`Summary`}{" "}
                <Tooltip content={t`summary experience`}>
                  <i className="fas fa-info-circle text-orange-500"></i>
                </Tooltip>
              </FormLabel>
              <FormControl>
                <RichInput
                  {...field}
                  content={field.value}
                  onChange={(value) => field.onChange(value)}
                  footer={(editor) => (
                    <AiActions value={editor.getText()} onChange={editor.commands.setContent} />
                  )}
                />
              </FormControl>

              <FormMessage />
            </FormItem>
          )}
        />
        <div>
          <FormField
            name="currently_working"
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel style={{ marginRight: "7px" }}>I am currently working here</FormLabel>
                <FormControl className="items-center " style={{ position: "relative", top: "3px" }}>
                  <Checkbox
                    checked={field.value ? true : false}
                    onCheckedChange={(data: boolean) => {
                      toggleVisibility(data);
                      field.onChange(data);
                    }}
                  ></Checkbox>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </SectionDialog>
  );
};
